import React from 'react';
import styled from 'styled-components';
import rmq from 'styled-rmq';
import SiteConfig from '../../config/SiteConfig';
import AnchorStyle from '../Basic/AnchorStyle';
import Container from '../Basic/Container';
import Countdown from '../Basic/Countdown';
import EUp from '../Emoji/EUp';

const Wrap = styled.div`
	display: table;
	width: 100%;
	text-align: center;
	margin: ${props => props.theme.vr * 2}rem auto ${props => props.theme.vr * 10}rem;

	a {
		font-size: 2rem;
		padding: 1rem;

		${rmq('525')} {
			font-size: 1.6rem;
		}
	}
`;

const CDown = styled.div`
	margin: ${props => props.theme.vr * 1}rem auto;
`;

export default () => (
	<Container>
		<Wrap>
			<AnchorStyle href="#signup" className="footerLink">
				Let me help you become a VSCode Power User! <EUp />
			</AnchorStyle>
			<CDown>
				<Countdown date={SiteConfig.countdownDate} />
			</CDown>
		</Wrap>
	</Container>
);
